export const initialAsyncState = {
    items: [],
    count: 0,
    offset: 0,
    loading: false,
};
export const axiosNormalizeResponse = (response) => response.data.result;
//# sourceMappingURL=FTLSelectModel.js.map